<template>
  <ReportDataTable
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.date',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportDataTable from "@/own/components/reports/ReportDataTable.vue";
export default {
  name: "ReverseLogistics",
  components: { ReportDataTable },
  data: () => ({
    urls: {
      data_url: "/reports/reverseLogistics",
      show_url: "/reports/reverseLogistics/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
